module.exports = "/_next/static/images/cb4757ed4cc271d51eb7d7381d638f01-man-looking-up-smiling-md@3x.jpg.webp";